import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_07fce31c from 'nuxt_plugin_sentryserver_07fce31c' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_bb791cd8 from 'nuxt_plugin_sentryclient_bb791cd8' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_71e906ac from 'nuxt_plugin_plugin_71e906ac' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_nuxtuseragent_d369cfbe from 'nuxt_plugin_nuxtuseragent_d369cfbe' // Source: ./nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_image_e1920f5a from 'nuxt_plugin_image_e1920f5a' // Source: ./image.js (mode: 'all')
import nuxt_plugin_intercomplugin_58db7533 from 'nuxt_plugin_intercomplugin_58db7533' // Source: ./nuxt-intercom/intercom-plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_2237eb00 from 'nuxt_plugin_cookieuniversalnuxt_2237eb00' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_2e518de3 from 'nuxt_plugin_pluginutils_2e518de3' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_d3b3a324 from 'nuxt_plugin_pluginrouting_d3b3a324' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7bf103c1 from 'nuxt_plugin_pluginmain_7bf103c1' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_gtm_2e27b82e from 'nuxt_plugin_gtm_2e27b82e' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_b7a00950 from 'nuxt_plugin_axios_b7a00950' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_vueshortkey_824caf0e from 'nuxt_plugin_vueshortkey_824caf0e' // Source: ../plugins/vue-shortkey.js (mode: 'client')
import nuxt_plugin_vuetextareaautosize_4e30078f from 'nuxt_plugin_vuetextareaautosize_4e30078f' // Source: ../plugins/vue-textarea-autosize.js (mode: 'client')
import nuxt_plugin_filterscontent_fca093cc from 'nuxt_plugin_filterscontent_fca093cc' // Source: ../plugins/filters-content.ts (mode: 'all')
import nuxt_plugin_truncatestring_807644da from 'nuxt_plugin_truncatestring_807644da' // Source: ../plugins/truncate-string.js (mode: 'all')
import nuxt_plugin_headhreflangs_d8263768 from 'nuxt_plugin_headhreflangs_d8263768' // Source: ../plugins/head-hreflangs.ts (mode: 'all')
import nuxt_plugin_headjsonld_48bb2329 from 'nuxt_plugin_headjsonld_48bb2329' // Source: ../plugins/head-json-ld.ts (mode: 'all')
import nuxt_plugin_headmeta_bafb37e2 from 'nuxt_plugin_headmeta_bafb37e2' // Source: ../plugins/head-meta.ts (mode: 'all')
import nuxt_plugin_intercom_260a5774 from 'nuxt_plugin_intercom_260a5774' // Source: ../plugins/intercom.ts (mode: 'all')
import nuxt_plugin_genericRedirectHandler_47d31b62 from 'nuxt_plugin_genericRedirectHandler_47d31b62' // Source: ../plugins/genericRedirectHandler.ts (mode: 'all')
import nuxt_plugin_profitwell_6d077932 from 'nuxt_plugin_profitwell_6d077932' // Source: ../plugins/profitwell.ts (mode: 'all')
import nuxt_plugin_vuejspopover_46888cbb from 'nuxt_plugin_vuejspopover_46888cbb' // Source: ../plugins/vue-js-popover.js (mode: 'client')
import nuxt_plugin_gtm_2cfa8501 from 'nuxt_plugin_gtm_2cfa8501' // Source: ../plugins/gtm.ts (mode: 'client')
import nuxt_plugin_api_228341c7 from 'nuxt_plugin_api_228341c7' // Source: ../plugins/api.ts (mode: 'all')
import nuxt_plugin_mzanalyticsapi_701da4a6 from 'nuxt_plugin_mzanalyticsapi_701da4a6' // Source: ../plugins/mz-analytics-api.ts (mode: 'all')
import nuxt_plugin_universallogin_6ed2315a from 'nuxt_plugin_universallogin_6ed2315a' // Source: ../plugins/universal-login.ts (mode: 'all')
import nuxt_plugin_auth_5b9ae2d8 from 'nuxt_plugin_auth_5b9ae2d8' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_axios_397e54eb from 'nuxt_plugin_axios_397e54eb' // Source: ../plugins/axios.ts (mode: 'all')
import nuxt_plugin_auth_37218c11 from 'nuxt_plugin_auth_37218c11' // Source: ../plugins/auth.ts (mode: 'all')
import nuxt_plugin_amplitude_2884d884 from 'nuxt_plugin_amplitude_2884d884' // Source: ../plugins/amplitude.ts (mode: 'all')
import nuxt_plugin_amplitudeexperiment_a341745c from 'nuxt_plugin_amplitudeexperiment_a341745c' // Source: ../plugins/amplitude-experiment.ts (mode: 'all')
import nuxt_plugin_download_6bdf8f31 from 'nuxt_plugin_download_6bdf8f31' // Source: ../plugins/download.ts (mode: 'all')
import nuxt_plugin_algoliaevents_0f781c84 from 'nuxt_plugin_algoliaevents_0f781c84' // Source: ../plugins/algolia-events.ts (mode: 'all')
import nuxt_plugin_ga_22722a9f from 'nuxt_plugin_ga_22722a9f' // Source: ../plugins/ga.ts (mode: 'all')
import nuxt_plugin_meta_601e7a3c from 'nuxt_plugin_meta_601e7a3c' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s | Teach Starter","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Teach Starter offers a range of time-saving, educational teaching resources for primary school teachers. Download unit and lesson plans, educational posters, classroom games and activities, worksheets and more!"},{"hid":"og-site_name","property":"og:site_name","content":"Teach Starter"},{"hid":"og-type","property":"og:type","content":"website"},{"hid":"og-image","property":"og:image","content":"https:\u002F\u002Fwww.teachstarter.com\u002Fimages\u002Fshare_image.png"},{"hid":"google-site-verification-1","name":"google-site-verification","content":"WsxQUL3UmYon9tVwVOhQ19TRX_y4Jqr8NrGgZe2n3hk"},{"hid":"google-site-verification-2","name":"google-site-verification","content":"KJL4IQGx8tM3t0HDvdFtSkY-RN4d2AywHSwTKrUiRBA"},{"hid":"robots:max-image-preview","name":"robots","content":"max-image-preview:large"}],"link":[{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon.png"},{"rel":"search","type":"application\u002Fopensearchdescription+xml","href":"\u002Fopensearch.xml","title":"Search teaching resources"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":true},{"rel":"preload","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap","as":"style"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap"}],"script":[{"hid":"maze","innerHTML":"!function(e,a,t,s){var i,n;try{n=e.sessionStorage.getItem(\"maze-us\")}catch(m){}if(!n){n=new Date().getTime();try{e.sessionStorage.setItem(\"maze-us\",n)}catch(r){}}(i=a.createElement(\"script\")).src=t+\"?t=\"+n+\"&apiKey=\"+s,a.getElementsByTagName(\"head\")[0].appendChild(i),e.mazeUniversalSnippetApiKey=s}(window,document,\"https:\u002F\u002Fsnippet.maze.co\u002Fmaze-universal-loader.js\",\"d9b5d7a4-b4f8-473c-8880-7a4e6ebaaf19\");","async":true,"defer":true},{"hid":"squatch","innerHTML":"!function(a,b){a(\"squatch\",\"https:\u002F\u002Ffast.ssqt.io\u002Fsquatch-js@2\",b)}(function(a,b,c){var d,e,f;c[\"_\"+a]={},c[a]={},c[a].ready=function(b){c[\"_\" + a].ready =  c[\"_\" + a].ready || [];c[\"_\" + a].ready.push(b);},e=document.createElement(\"script\"),e.async=1,e.src=b,f=document.getElementsByTagName(\"script\")[0],f.parentNode.insertBefore(e,f)},this);","type":"text\u002Fjavascript","async":true,"defer":true},{},{},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"__dangerouslyDisableSanitizersByTagID":{"maze":["innerHTML"],"squatch":["innerHTML"],"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]},"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_07fce31c === 'function') {
    await nuxt_plugin_sentryserver_07fce31c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_bb791cd8 === 'function') {
    await nuxt_plugin_sentryclient_bb791cd8(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_71e906ac === 'function') {
    await nuxt_plugin_plugin_71e906ac(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_d369cfbe === 'function') {
    await nuxt_plugin_nuxtuseragent_d369cfbe(app.context, inject)
  }

  if (typeof nuxt_plugin_image_e1920f5a === 'function') {
    await nuxt_plugin_image_e1920f5a(app.context, inject)
  }

  if (typeof nuxt_plugin_intercomplugin_58db7533 === 'function') {
    await nuxt_plugin_intercomplugin_58db7533(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_2237eb00 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_2237eb00(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_2e518de3 === 'function') {
    await nuxt_plugin_pluginutils_2e518de3(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_d3b3a324 === 'function') {
    await nuxt_plugin_pluginrouting_d3b3a324(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7bf103c1 === 'function') {
    await nuxt_plugin_pluginmain_7bf103c1(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_2e27b82e === 'function') {
    await nuxt_plugin_gtm_2e27b82e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_b7a00950 === 'function') {
    await nuxt_plugin_axios_b7a00950(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueshortkey_824caf0e === 'function') {
    await nuxt_plugin_vueshortkey_824caf0e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetextareaautosize_4e30078f === 'function') {
    await nuxt_plugin_vuetextareaautosize_4e30078f(app.context, inject)
  }

  if (typeof nuxt_plugin_filterscontent_fca093cc === 'function') {
    await nuxt_plugin_filterscontent_fca093cc(app.context, inject)
  }

  if (typeof nuxt_plugin_truncatestring_807644da === 'function') {
    await nuxt_plugin_truncatestring_807644da(app.context, inject)
  }

  if (typeof nuxt_plugin_headhreflangs_d8263768 === 'function') {
    await nuxt_plugin_headhreflangs_d8263768(app.context, inject)
  }

  if (typeof nuxt_plugin_headjsonld_48bb2329 === 'function') {
    await nuxt_plugin_headjsonld_48bb2329(app.context, inject)
  }

  if (typeof nuxt_plugin_headmeta_bafb37e2 === 'function') {
    await nuxt_plugin_headmeta_bafb37e2(app.context, inject)
  }

  if (typeof nuxt_plugin_intercom_260a5774 === 'function') {
    await nuxt_plugin_intercom_260a5774(app.context, inject)
  }

  if (typeof nuxt_plugin_genericRedirectHandler_47d31b62 === 'function') {
    await nuxt_plugin_genericRedirectHandler_47d31b62(app.context, inject)
  }

  if (typeof nuxt_plugin_profitwell_6d077932 === 'function') {
    await nuxt_plugin_profitwell_6d077932(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuejspopover_46888cbb === 'function') {
    await nuxt_plugin_vuejspopover_46888cbb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_2cfa8501 === 'function') {
    await nuxt_plugin_gtm_2cfa8501(app.context, inject)
  }

  if (typeof nuxt_plugin_api_228341c7 === 'function') {
    await nuxt_plugin_api_228341c7(app.context, inject)
  }

  if (typeof nuxt_plugin_mzanalyticsapi_701da4a6 === 'function') {
    await nuxt_plugin_mzanalyticsapi_701da4a6(app.context, inject)
  }

  if (typeof nuxt_plugin_universallogin_6ed2315a === 'function') {
    await nuxt_plugin_universallogin_6ed2315a(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_5b9ae2d8 === 'function') {
    await nuxt_plugin_auth_5b9ae2d8(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_397e54eb === 'function') {
    await nuxt_plugin_axios_397e54eb(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_37218c11 === 'function') {
    await nuxt_plugin_auth_37218c11(app.context, inject)
  }

  if (typeof nuxt_plugin_amplitude_2884d884 === 'function') {
    await nuxt_plugin_amplitude_2884d884(app.context, inject)
  }

  if (typeof nuxt_plugin_amplitudeexperiment_a341745c === 'function') {
    await nuxt_plugin_amplitudeexperiment_a341745c(app.context, inject)
  }

  if (typeof nuxt_plugin_download_6bdf8f31 === 'function') {
    await nuxt_plugin_download_6bdf8f31(app.context, inject)
  }

  if (typeof nuxt_plugin_algoliaevents_0f781c84 === 'function') {
    await nuxt_plugin_algoliaevents_0f781c84(app.context, inject)
  }

  if (typeof nuxt_plugin_ga_22722a9f === 'function') {
    await nuxt_plugin_ga_22722a9f(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_601e7a3c === 'function') {
    await nuxt_plugin_meta_601e7a3c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
